export const QUERY_PARAMS_FILTER = {
    GENDER: "gender",
    AGE: "age",
    SORT: "sort",
    LEADER_TYPE: "leader_type",
    CATEGORY: "category",
};
